import './Accessories.scss'

export const Accessories = () => {
  return (
    <h1>Accessories</h1>
  );
}